import React from 'react';
import { Button } from '../primitives';

/** PHLD.ai — Header (minimal, single-page nav). Blurs in on scroll. */
export function Header() {
  const [scrolled, setScrolled] = React.useState(false);
  React.useEffect(() => {
    const root: any = document.querySelector('[data-phld-scroll]') || window;
    const onScroll = () => {
      const y = root === window ? window.scrollY : root.scrollTop;
      setScrolled(y > 24);
    };
    root.addEventListener('scroll', onScroll);
    return () => root.removeEventListener('scroll', onScroll);
  }, []);

  const wrap: React.CSSProperties = {
    position: 'sticky',
    top: 0,
    zIndex: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 var(--gutter)',
    height: '74px',
    background: scrolled ? 'rgba(247,244,240,0.82)' : 'transparent',
    backdropFilter: scrolled ? 'saturate(180%) blur(12px)' : 'none',
    borderBottom: scrolled ? '1px solid var(--border)' : '1px solid transparent',
    transition: 'background var(--dur-base) var(--ease-out), border-color var(--dur-base) var(--ease-out)',
  };
  const brand: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '6px',
    textDecoration: 'none',
  };
  const word: React.CSSProperties = {
    fontWeight: 'var(--weight-medium)' as any,
    fontSize: '13px',
    letterSpacing: '0.42em',
    color: 'var(--ink-900)',
    paddingLeft: '0.42em',
  };
  const nav: React.CSSProperties = { display: 'flex', alignItems: 'center', gap: 'var(--space-7)' };
  const link: React.CSSProperties = {
    fontSize: 'var(--text-small)',
    color: 'var(--text-muted)',
    fontWeight: 'var(--weight-regular)' as any,
    letterSpacing: '0.01em',
    cursor: 'pointer',
    transition: 'color var(--dur-base) var(--ease-out)',
  };

  return (
    <header style={wrap}>
      <a href="#top" style={brand} aria-label="PHLD.ai home">
        <img src="/assets/brand/phld-mark-navy.svg" alt="" style={{ height: '34px', width: 'auto' }} />
        <span style={word}>PHLD</span>
      </a>
      <nav style={nav} className="phld-desktop-nav">
        {['The work', 'How it works', 'The story'].map((l) => (
          <a
            key={l}
            href={'#' + l.toLowerCase().replace(/\s+/g, '-')}
            style={link}
            onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--ink-900)')}
            onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--text-muted)')}
          >
            {l}
          </a>
        ))}
        <Button size="sm" href="#contact">
          Let&apos;s talk
        </Button>
      </nav>
    </header>
  );
}
